import DocumentDisplay from './DocumentDisplay'

export default DocumentDisplay
